module.exports = __webpack_public_path__ + "img/2x.502b937.jpg";